if (!customElements.get("truncated-text")) {
  class ComponentTruncatedText extends HTMLElement {
    constructor() {
      super();
      this.showMoreBtn = this.querySelector(".view-more-btn");
      this.truncText = this.querySelector(".truncated");
      this.fullText = this.querySelector(".full");

      if(this.showMoreBtn){

        this.fullText.insertAdjacentHTML('afterend', '<button class="view-less-btn link hide">View less</button>');
        this.showLessBtn = this.querySelector(".view-less-btn");

        this.showMoreBtn.addEventListener('click', () => {
          this.showMoreBtn.style.display = 'none';
          this.truncText.style.display = 'none';
          this.fullText.style.display = 'block';
          this.fullText.classList.remove('hide');
          this.showLessBtn.classList.remove('hide');
        });

        this.showLessBtn.addEventListener('click', () => {
          this.showMoreBtn.style.display = 'inline-block';
          this.truncText.style.display = 'block';
          this.fullText.style.display = 'none';
          this.fullText.classList.add('hide');
          this.showLessBtn.classList.add('hide');
        });





      }

      
    }

    
  }
  customElements.define("truncated-text", ComponentTruncatedText);
}
